import { SyndicatedContentProviderName, SyndicatedContentKeys, FlixMatchEvent } from './types';

export const SYNDICATED_CONTENT_KEYS: {
  AU: SyndicatedContentKeys;
  NZ: SyndicatedContentKeys;
} = {
  AU: {
    FLIX_DISTRIBUTOR: '2298',
    ONEWORLD_SKEY: '0861b5db',
    ONEWORLD_ZONE_ID: 'a8d0754063',
  },
  NZ: {
    FLIX_DISTRIBUTOR: '5394',
    ONEWORLD_SKEY: '0861b5db',
    ONEWORLD_ZONE_ID: '69f3b453f1',
  },
};

export const SYNDICATED_CONTENT_PROVIDER_NAME: {
  FLIX: SyndicatedContentProviderName['flix'];
  SYNDIGO: SyndicatedContentProviderName['syndigo'];
  ONE_WORLD_SYNC: SyndicatedContentProviderName['oneWorldSync'];
  CONTENT_DRIVER: SyndicatedContentProviderName['contentDriver'];
} = {
  FLIX: 'flix',
  SYNDIGO: 'syndigo',
  ONE_WORLD_SYNC: '1worldsync',
  CONTENT_DRIVER: 'content-driver',
};

export const FLIX_MATCH_EVENT: {
  VALID: FlixMatchEvent['valid'];
  INVALID: FlixMatchEvent['invalid'];
} = {
  VALID: 'matchhit',
  INVALID: 'matchmiss',
};
